import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, gameState } from '@js/state';

var leftButton = null;
var rightButton = null;
var panel = null;
var progressBar = null;
var light_1 = null;
var light_2 = null;
var light_3 = null;
var light_4 = null;
var light_5 = null;
var light_6 = null;
var hintOpen = false;
var qnum = 0;
var True_tree = true;
var True_strip = true;
var qstatement = null;
var replayCount = 0;
var option = 0;
var checkOption = 0;
var adjustTimeScale = 1;
var hintOn = false;
var attempt = 0;
var correct = 0;
var attempts = 0;

var correctOption = null;

var c = null;

var replay_test = true;
var checkTest = false;
var tCheck = true;
var t_test = true;
export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: "GameScene",
    });
  }

  preload() {
 }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    //gameState.gameWin = true;

    this.carRunning = this.sound.add("carRunning");

    this.ta1 = this.sound.add("ta1").setVolume(0.1);
    this.ta2 = this.sound.add("ta2").setVolume(0.1);

    config.audio.caraudio.on(
      "complete",
      () => {
        this.carRunning.setLoop(true).setVolume(0.03).play();
      },
      this
    );

    this.background();

    this.tutorialOperator();

    this.gameOperator();

    this.hintAnimations();

    panel = this.add
      .image(config.width / 2, 720, "panel")
      .setOrigin(0.5, 1)
      .setDepth(9);

    leftButton = this.add.image(760, 830, "left arrow").setOrigin(0.5, 0.5).setInteractive({ cursor: "pointer" });
    rightButton = this.add.image(880, 830, "right arrow").setOrigin(0.5, 0.5).setInteractive({ cursor: "pointer" });

    this.greenLesser = this.add.image(481, 670, "greenLesser").setDepth(10).setScale(0, 0);
    this.greenEqual = this.add.image(481, 670, "greenEqual").setDepth(10).setScale(0, 0);
    this.greenGreater = this.add.image(481, 670, "greenGreater").setDepth(10).setScale(0, 0);

    this.turns();

    this.correct();

    this.wrong();

    this.hittingTheOption();

    this.buttonActivity();

    this.showPanel();
    progressBar = this.add
      .image(config.width / 2, 0, "progressBar")
      .setOrigin(0.5, 0)
      .setDepth(7);
    this.overlay = this.add.image(0, 0, "overlay").setOrigin(0, 0).setDepth(7);

    this.ta1.play();

    this.text = this.add.image(config.width / 2, config.height / 2, "text").setDepth(8);
    this.car = this.physics.add
      .sprite(config.width / 2, 500, "Car")
      .setDepth(8)
      .setVisible(false);

    this.time.delayedCall(
      6000,
      () => {
        //animation for button keys
        this.enableButtons();

        //display tutorial operators on top
        this.t_equal.setDepth(8);
        this.t_greater.setDepth(8);
        this.t_lesser.setDepth(8);

        this.ta2.play();
        this.text_2 = this.add.image(config.width / 2, config.height / 2, "text_2").setDepth(8);
        this.text.setScale(0, 0);

        leftButton.setDepth(10);
        rightButton.setDepth(10);
      },
      [],
      this
    );

    this.greenLights();

    this.handleHintButton();
  } //

  hittingTheOption() {
    this.optionHitCorrect = this.add
      .sprite(config.width / 2, config.height / 2, "optionHitCorrect")
      .setDepth(7)
      .setVisible(false);
    this.optionHitWrong = this.add
      .sprite(config.width / 2, config.height / 2, "optionHitWrong")
      .setDepth(7)
      .setVisible(false);

    this.anims.create({
      key: "optionHitCorrect",
      frames: this.anims.generateFrameNames("optionHitCorrect", {
        start: 0,
        end: 86,
        zeroPad: 0,
        prefix: "optionscorrect",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "optionHitWrong",
      frames: this.anims.generateFrameNames("optionHitWrong", {
        start: 0,
        end: 56,
        zeroPad: 0,
        prefix: "optionwrong",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  turns() {
    this.carLeftTurn = this.add.sprite(config.width / 2, config.height / 2, "carLeftTurn").setDepth(8);

    this.carRightTurn = this.add
      .sprite(config.width / 2, config.height / 2, "carRightTurn")
      .setDepth(8)
      .setVisible(false);

    this.anims.create({
      key: "carLeftTurn",
      frames: this.anims.generateFrameNames("carLeftTurn", {
        start: 0,
        end: 20,
        zeroPad: 0,
        prefix: "leftturn",
        suffix: ".png",
      }),
      frameRate: 25,
      repeat: 0,
    });

    this.anims.create({
      key: "carRightTurn",
      frames: this.anims.generateFrameNames("carRightTurn", {
        start: 0,
        end: 20,
        zeroPad: 0,
        prefix: "rightturn",
        suffix: ".png",
      }),
      frameRate: 25,
      repeat: 0,
    });
  }

  correct() {
    this.carRightCorrect = this.add
      .sprite(config.width / 2, config.height / 2, "carRightCorrect")
      .setDepth(8)
      .setVisible(false);

    this.carLeftCorrect = this.add
      .sprite(config.width / 2, config.height / 2, "carLeftCorrect")
      .setDepth(8)
      .setVisible(false);

    this.carCenterCorrect = this.add
      .sprite(config.width / 2, config.height / 2, "carCenterCorrect")
      .setDepth(8)
      .setVisible(false);

    this.anims.create({
      key: "carRightCorrect",
      frames: this.anims.generateFrameNames("carRightCorrect", {
        start: 0,
        end: 6,
        zeroPad: 0,
        prefix: "RIGHT",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "carLeftCorrect",
      frames: this.anims.generateFrameNames("carLeftCorrect", {
        start: 0,
        end: 6,
        zeroPad: 0,
        prefix: "LEFT",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "carCenterCorrect",
      frames: this.anims.generateFrameNames("carCenterCorrect", {
        start: 0,
        end: 6,
        zeroPad: 0,
        prefix: "CENTRE",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  wrong() {
    this.carRightWrong = this.add
      .sprite(config.width / 2, config.height / 2, "carRightWrong")
      .setDepth(8)
      .setVisible(false);
    this.carLeftWrong = this.add
      .sprite(config.width / 2, config.height / 2, "carLeftWrong")
      .setDepth(8)
      .setVisible(false);
    this.carCenterWrong = this.add
      .sprite(config.width / 2, config.height / 2, "carCenterWrong")
      .setDepth(8)
      .setVisible(false);

    this.anims.create({
      key: "carRightWrong",
      frames: this.anims.generateFrameNames("carRightWrong", {
        start: 0,
        end: 117,
        zeroPad: 0,
        prefix: "wrongright",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "carLeftWrong",
      frames: this.anims.generateFrameNames("carLeftWrong", {
        start: 0,
        end: 117,
        zeroPad: 0,
        prefix: "wrongleft",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "carCenterWrong",
      frames: this.anims.generateFrameNames("carCenterWrong", {
        start: 0,
        end: 109,
        zeroPad: 0,
        prefix: "wrongCenter",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  tutorialOperator() {
    this.tut = this.physics.add.group();
    this.t_greater = this.physics.add.sprite(640, 140, "greater").setVisible(true);
    this.t_lesser = this.physics.add.sprite(600, 140, "lesser").setVisible(true);
    this.t_equal = this.physics.add.sprite(1280 - 600, 140, "equal").setVisible(true);

    this.tut.add(this.t_equal);
    this.tut.add(this.t_greater);
    this.tut.add(this.t_lesser);
  }

  gameOperator() {
    this.left = this.physics.add.group();

    this.l_greater = this.physics.add.sprite(600, 140, "greater").setVisible(false);
    this.l_equal = this.physics.add.sprite(600, 140, "equal").setVisible(false);
    this.l_lesser = this.physics.add.sprite(600, 140, "lesser").setVisible(false);

    this.left.add(this.l_greater);
    this.left.add(this.l_equal);
    this.left.add(this.l_lesser);

    this.right = this.physics.add.group();

    this.r_greater = this.physics.add.sprite(1280 - 600, 140, "greater").setVisible(false);
    this.r_equal = this.physics.add.sprite(1280 - 600, 140, "equal").setVisible(false);
    this.r_lesser = this.physics.add.sprite(1280 - 600, 140, "lesser").setVisible(false);

    this.right.add(this.r_greater);
    this.right.add(this.r_equal);
    this.right.add(this.r_lesser);

    this.mid = this.physics.add.group();
    this.m_greater = this.physics.add.sprite(640, 140, "greater").setVisible(false);
    this.m_equal = this.physics.add.sprite(640, 140, "equal").setVisible(false);
    this.m_lesser = this.physics.add.sprite(640, 140, "lesser").setVisible(false);

    this.mid.add(this.m_greater);
    this.mid.add(this.m_equal);
    this.mid.add(this.m_lesser);
  }

  hintAnimations() {
    this.hint = this.add.sprite(80, 650, "hint_1").setVisible(false).setOrigin(0, 1).setDepth(11);
    this.closeHintButton = this.add
      .sprite(535.33 - 8, 390.67 + 5, "closeHint")
      .setVisible(false)
      .setDepth(12)
      .setInteractive({ cursor: "pointer" })
      .setOrigin(0);
    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(12).setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 1,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  showPanel() {
    this.createQuestion();
    if (qnum > 0) {
      this.enableButtons();

      leftButton.setDepth(10);
      rightButton.setDepth(10);
    }

    this.tweens.add({
      targets: panel,
      ease: "Sine.easeOut",
      duration: 800,
      delay: 0,
      y: {
        getStart: () => 900,
        getEnd: () => 720,
      },
      yoyo: false,
      loop: 0,
      onComplete: function () {
        //tween.remove();
      },
    });

    this.tweens.add({
      targets: qstatement,
      ease: "Sine.easeOut",
      duration: 800,
      delay: 0,
      y: {
        getStart: () => 885,
        getEnd: () => 705,
      },
      yoyo: false,
      loop: 0,
      onComplete: function () {
        //tween.remove();
      },
    });
  }

  buttonActivity() {
    leftButton.setInteractive().on("pointerdown", () => {
      if (c == 0) {
        config.audio.lanechangeaudio.play();
        this.carLeftTurn.setVisible(true);
        this.carRightTurn.setVisible(false);
        this.carLeftTurn.play("carLeftTurn");

        this.car.x = this.car.x - 450;
      } else if (c == 1) {
        config.audio.lanechangeaudio.play();

        this.carLeftTurn.setVisible(false);
        this.carRightTurn.setVisible(true);
        this.carRightTurn.playReverse("carRightTurn");

        this.car.x = this.car.x - 450;
      }
    });

    rightButton.setInteractive().on("pointerdown", () => {
      if (c == 0) {
        config.audio.lanechangeaudio.play();
        this.carLeftTurn.setVisible(false);
        this.carRightTurn.setVisible(true);
        this.carRightTurn.play("carRightTurn");

        this.car.x = this.car.x + 450;
      } else if (c == -1) {
        config.audio.lanechangeaudio.play();
        this.carLeftTurn.setVisible(true);
        this.carRightTurn.setVisible(false);
        this.carLeftTurn.playReverse("carLeftTurn");

        this.car.x = this.car.x + 450;
      }
    });
  }

  createQuestion() {
    if (qnum == 0) {
      qstatement = this.add.image(400, 900, "Q1").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 1) {
      qstatement = this.add.image(400, 900, "Q2").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 2) {
      qstatement = this.add.image(400, 900, "Q3").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 3) {
      qstatement = this.add.image(400, 900, "Q4").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 4) {
      qstatement = this.add.image(400, 900, "Q5").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 5) {
      qstatement = this.add.image(400, 900, "Q6").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 6) {
      qstatement = this.add.image(400, 900, "Q7").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 7) {
      qstatement = this.add.image(400, 900, "Q8").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 8) {
      qstatement = this.add.image(400, 900, "Q9").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 9) {
      qstatement = this.add.image(400, 900, "Q10").setOrigin(0, 1).setDepth(9);
    } else if (qnum == 10) {
      qstatement = this.add.image(400, 900, "Q2").setOrigin(0, 1).setDepth(9);
    }
  }

  removePanel() {
    this.disapperButtons();

    this.greenLesser.setVisible(false);
    this.greenGreater.setVisible(false);
    this.greenEqual.setVisible(false);
    qstatement.destroy();

    this.tweens.add({
      targets: panel,
      ease: "Sine.easeOut",
      duration: 800,
      delay: 0,
      y: {
        getStart: () => 720,
        getEnd: () => 900,
      },
      yoyo: false,
      loop: 0,
      onComplete: function () {
        //tween.remove();
      },
    });
  }

  background() {
    var r1 = this.add.rectangle(0, 115, config.width, config.height, 0xddffe4).setOrigin(0, 0);
    //this.add.image(200,170,'bush')
    //this.add.image(1200,140,'bush')
    //this.add.image(1050,155,'bush')
    //this.add.image(170,200,'rock')
    //this.add.image(1170,185,'rock')
    var x_adjust = 850;
    var t2 = this.add.triangle(0, 0, -x_adjust, config.height, config.width / 2, 110, config.width + x_adjust, config.height, 0xafe8c2).setOrigin(0, 0);

    x_adjust = 530;
    var t1 = this.add.triangle(0, 0, -x_adjust, config.height, config.width / 2, 113, config.width + x_adjust, config.height, 0x888888).setOrigin(0, 0);

    this.bush_1 = this.physics.add.sprite(640, 110, "bush");
    this.time.delayedCall(
      300,
      () => {
        this.bush_1.x = 640;
        this.bush_1.y = 110;
        this.bush_1.setVelocity(0, 0);
      },
      [],
      this
    );

    this.bush_3 = this.physics.add.sprite(640, 110, "bush");
    this.time.delayedCall(
      3300,
      () => {
        this.bush_3.x = 640;
        this.bush_3.y = 110;
        this.bush_3.setVelocity(0, 0);
      },
      [],
      this
    );

    this.rock_1 = this.physics.add.sprite(640, 110, "rock");
    this.time.delayedCall(
      1300,
      () => {
        this.rock_1.x = 640;
        this.rock_1.y = 110;
        this.rock_1.setVelocity(0, 0);
      },
      [],
      this
    );

    this.rock_2 = this.physics.add.sprite(640, 110, "rock");
    this.time.delayedCall(
      2800,
      () => {
        this.rock_2.x = 640;
        this.rock_2.y = 110;
        this.rock_2.setVelocity(0, 0);
      },
      [],
      this
    );

    this.bush_2 = this.physics.add.sprite(640, 110, "bush");
    this.bush_4 = this.physics.add.sprite(640, 110, "bush");
    this.time.delayedCall(
      3900,
      () => {
        this.bush_4.x = 640;
        this.bush_4.y = 110;
        this.bush_4.setVelocity(0, 0);
      },
      [],
      this
    );

    this.createTrees();
    this.createStrips();

    this.finish = this.physics.add.sprite(640, 110, "finish").setScale(0, 0).setDepth(4);

    this.sky = this.add
      .image(config.width / 2, 0, "sky")
      .setOrigin(0.5, 0)
      .setDepth(5);
  }

  createTrees() {
    this.trees = this.physics.add.group();

    this.right_trees = this.physics.add.group();

    this.trees.create(297, 261, "tree").setOrigin(1, 1);
    this.trees.create(511, 166, "tree").setOrigin(1, 1);
    this.trees.create(590, 130, "tree").setOrigin(1, 1).setDepth(4);
    this.trees.create(622, 117, "tree").setOrigin(1, 1).setDepth(4);
    this.trees.create(634, 112, "tree").setOrigin(1, 1).setDepth(4);
    this.trees.create(638.4, 110.7, "tree").setOrigin(1, 1).setDepth(4);
    this.trees.create(640, 110, "tree").setOrigin(1, 1).setDepth(4);

    this.right_trees.create(1280 - 297, 261, "tree").setOrigin(0, 1);
    this.right_trees.create(1280 - 511, 166, "tree").setOrigin(0, 1);
    this.right_trees
      .create(1280 - 590, 130, "tree")
      .setOrigin(0, 1)
      .setDepth(4);
    this.right_trees
      .create(1280 - 622, 117, "tree")
      .setOrigin(0, 1)
      .setDepth(4);
    this.right_trees
      .create(1280 - 634, 112, "tree")
      .setOrigin(0, 1)
      .setDepth(4);
    this.right_trees
      .create(1280 - 638.4, 110.7, "tree")
      .setOrigin(0, 1)
      .setDepth(4);
    this.right_trees.create(640, 110, "tree").setOrigin(0, 1).setDepth(4);
  }

  createStrips() {
    this.left_strip = this.physics.add.group();

    this.right_strip = this.physics.add.group();

    this.left_strip.create(81.52, 1070, "left strip").setOrigin(1, 1);
    this.left_strip.create(297.5, 699, "left strip").setOrigin(1, 1);
    this.left_strip.create(430.1, 470.7, "left strip").setOrigin(1, 1);
    this.left_strip.create(511.5, 330.8, "left strip").setOrigin(1, 1);
    this.left_strip.create(561.5, 245, "left strip").setOrigin(1, 1);
    this.left_strip.create(592, 192, "left strip").setOrigin(1, 1);
    this.left_strip.create(611, 160, "left strip").setOrigin(1, 1);
    this.left_strip.create(622.6, 140, "left strip").setOrigin(1, 1);
    this.left_strip.create(629.7, 127.6, "left strip").setOrigin(1, 1);
    this.left_strip.create(634, 120.2, "left strip").setOrigin(1, 1);
    this.left_strip.create(636.7, 115.6, "left strip").setOrigin(1, 1);
    this.left_strip.create(638.39, 112.8, "left strip").setOrigin(1, 1);
    this.left_strip.create(639.4, 111, "left strip").setOrigin(1, 1);
    this.left_strip.create(640, 110, "left strip").setOrigin(1, 1);

    this.right_strip.create(1280 - 81.52, 1070, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 297.5, 699, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 430.1, 470.7, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 511.5, 330.8, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 561.5, 245, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 592, 192, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 611, 160, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 622.6, 140, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 629.7, 127.6, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 634, 120.2, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 636.7, 115.6, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 638.39, 112.8, "right strip").setOrigin(0, 1);
    this.right_strip.create(1280 - 639.4, 111, "right strip").setOrigin(0, 1);
    this.right_strip.create(640, 110, "right strip").setOrigin(0, 1);
  }

  greenLights() {
    var light_gap = 55;
    light_1 = this.add.image(487, 75, "green").setVisible(false).setDepth(7);
    light_2 = this.add
      .image(487 + light_gap, 75, "green")
      .setVisible(false)
      .setDepth(7);
    light_3 = this.add
      .image(487 + 115, 75, "green")
      .setVisible(false)
      .setDepth(7);
    light_4 = this.add
      .image(487 + 3 * light_gap + 10, 75, "green")
      .setVisible(false)
      .setDepth(7);
    light_5 = this.add
      .image(487 + 4 * light_gap + 17, 75, "green")
      .setVisible(false)
      .setDepth(7);
    light_6 = this.add
      .image(487 + 5 * light_gap + 25, 75, "green")
      .setVisible(false)
      .setDepth(7);
  }

  handleHintButton() {
    this.hintButton.on(
      "pointerdown",
      function (pointer) {
        this.disableButtons();

        this.carRunning.setMute(true);

        hintOpen = true;

        gameState.hints += 1;
        this.overlay.setScale(1, 1).setDepth(11);
        this.hintButton.play("idle");

        if (qnum <= 4 || qnum == 10) {
          if (attempt == 2) {
            this.hint.setTexture("hint_1");
          } else {
            this.hint.setTexture("hint_2");
          }
        } else {
          if (attempt == 2) {
            this.hint.setTexture("hint_4");
          } else {
            this.hint.setTexture("hint_3");
          }
        }
        this.hint.setVisible(true);
        this.closeHintButton.setVisible(true);

        True_tree = false;
        True_strip = false;
      },
      this
    );

    this.closeHintButton.on(
      "pointerdown",
      function (pointer) {
        hintOpen = false;

        leftButton.setDepth(10);
        rightButton.setDepth(10);

        this.carRunning.setMute(false);

        leftButton.setInteractive();
        rightButton.setInteractive();

        True_tree = true;
        True_strip = true;

        this.overlay.setScale(0, 0);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");

        hintOn = false;

        this.physics.world.timeScale = 1;
      },
      this
    );
  }

  update() {
    if (hintOpen) {
      this.disableButtons();
    }

    this.carPosition();

    this.leftBush(this.bush_1, 10000);
    this.leftBush(this.bush_3, 20000);
    this.rightBush(this.bush_2, 10000);
    this.rightBush(this.bush_4, 20000);

    this.rockAnimation();

    this.treeMotion();
    this.operatorMotion();
    this.stripMotion();

    if (this.l_greater.y > 470 && qnum >= 1 && this.l_greater.y < 1000) {
      this.disableButtons();
    }

    if (this.l_greater.y > 480 && checkTest) {
      if (replayCount >= 2 && hintOn) {
        this.hintButton.play("pop_out");
      }
      checkTest = false;
      this.check();
    }

    // tutorial case
    if (qnum == 0) {
      if (c == -1) {
        this.disableButtons();
        if (this.t_greater.y > 500 && tCheck) {
          tCheck = false;
          this.playLeftOptionCorrect();
          this.onLight();
          this.t_lesser.setVisible(false);

          this.tweens.add({
            targets: this.greenLesser,
            ease: "Cubic",
            duration: 300,
            scale: { from: 0, to: 1 },
            yoyo: false,
            loop: 0,
          });
        }
        this.overlay.setScale(0, 0);
        this.text_2.setScale(0, 0);
        t_test = false;
        this.t_lesser.setVelocityX((-17 * (641 - this.t_lesser.x)) / 64);
        this.t_equal.setVelocityX((17 * (641 - this.t_lesser.x)) / 64);
        this.tut.getChildren().forEach((operator) => {
          operator.setScale((1.5 * (640 - this.t_lesser.x)) / 640);
          operator.setVelocityY((14 * (641 - this.t_lesser.x)) / 64);
        });
      } else if (this.t_greater.y > 290 && t_test) {
        this.tut.getChildren().forEach((operator) => {
          operator.setScale((1.5 * (640 - 400)) / 640);
          operator.setVelocityX(0);
          operator.setVelocityY(0);
        });
      } else {
        this.t_lesser.setVelocityX((-15 * (641 - this.l_greater.x)) / 64);
        this.t_equal.setVelocityX((15 * (641 - this.l_greater.x)) / 64);
        this.tut.getChildren().forEach((operator) => {
          operator.setScale((1.5 * (640 - this.l_greater.x)) / 640);
          operator.setVelocityY((14 * (641 - this.l_greater.x)) / 64);
        });
      }

      if (this.t_greater.y > 1500) {
        this.t_lesser.destroy();
        this.t_greater.destroy();
        this.t_equal.destroy();
        t_test = true;
        qnum = 1;

        this.removePanel();
      }
    } else if ((qnum == 11 || correct == 6) && !t_test) {
      this.finish.setScale((this.finish.y - 109) / 205);

      if (correct == 6) {
        config.audio.yayaudio.play();
      }

      if (this.finish.y >= 520) {
        config.audio.bgaudio.stop();

        this.carRunning.stop();

        gameState.attempted = qnum - 1;
        gameState.score = correct;
        gameState.questionNumber = qnum;
        console.log(gameState);

        this.scene.start("EndScene");
      } else {
        this.removePanel();
        this.disapperButtons();
        this.finish.setVelocityY(this.finish.y - 109);
        if (this.finish.y > 150) this.finish.setDepth(7);
        this.greenEqual.setScale(0, 0);
        this.greenLesser.setScale(0, 0);
        this.greenGreater.setScale(0, 0);

        panel.setScale(0, 0);

        this.carLeftCorrect.setVisible(false);
        this.carRightCorrect.setVisible(false);
        this.carCenterCorrect.setVisible(false);
      }
    }

    //questions
    else if ((qnum == 1 || qnum == 10) && t_test) {
      correctOption = -1;
      this.replay();
    } else if (qnum == 2 && t_test) {
      correctOption = -1;
      this.replay();
    } else if (qnum == 3 && t_test) {
      correctOption = 0;
      this.replay();
    } else if (qnum == 4 && t_test) {
      correctOption = -1;
      this.replay();
    } else if (qnum == 5 && t_test) {
      correctOption = -1;
      this.replay();
    } else if (qnum == 6 && t_test) {
      correctOption = 1;
      this.replay();
    } else if (qnum == 7 && t_test) {
      correctOption = 0;
      this.replay();
    } else if (qnum == 8 && t_test) {
      correctOption = 1;
      this.replay();
    } else if (qnum == 9 && t_test) {
      correctOption = -1;
      this.replay();
    }
  }

  playLeftOptionCorrect() {
    this.optionHitCorrect.x = 210;
    this.optionHitCorrect.y = 500;
    this.optionHitCorrect.play("optionHitCorrect").setVisible(true);
    this.carLeftCorrect.play("carLeftCorrect").setVisible(true);
  }

  playLeftOptionWrong() {
    this.optionHitWrong.x = 180;
    this.optionHitWrong.y = 520;
    this.optionHitWrong.play("optionHitWrong").setVisible(true);
    this.carLeftWrong.play("carLeftWrong").setVisible(true);
  }

  playRightOptionCorrect() {
    this.optionHitCorrect.x = 1090;
    this.optionHitCorrect.y = 500;
    this.optionHitCorrect.play("optionHitCorrect").setVisible(true);
    this.carRightCorrect.play("carRightCorrect").setVisible(true);
  }

  playRightOptionWrong() {
    this.optionHitWrong.x = 1100;
    this.optionHitWrong.y = 520;
    this.optionHitWrong.play("optionHitWrong").setVisible(true);
    this.carRightWrong.play("carRightWrong").setVisible(true);
  }

  playCenterOptionCorrect() {
    this.optionHitCorrect.x = 640;
    this.optionHitCorrect.y = 500;
    this.optionHitCorrect.play("optionHitCorrect").setVisible(true);
    this.carCenterCorrect.play("carCenterCorrect").setVisible(true);
  }

  playCenterOptionWrong() {
    this.optionHitWrong.x = 640;
    this.optionHitWrong.y = 520;
    this.optionHitWrong.play("optionHitWrong").setVisible(true);
    this.carCenterWrong.play("carCenterWrong").setVisible(true);
  }

  carPosition() {
    if (this.car.x > 700) {
      c = 1;
    } else if (this.car.x < 600) {
      c = -1;
    } else {
      c = 0;
    }
  }

  check() {
    if (c == 1) {
      this.right.setVisible(false);
    } else if (c == -1) {
      this.left.setVisible(false);
    } else {
      this.mid.setVisible(false);
    }
    if (correctOption == 1) {
      if ((checkOption == 1 && c == 1) || (checkOption == 2 && c == -1) || (checkOption == 3 && c == 1) || (checkOption == 4 && c == 0) || (checkOption == 5 && c == -1) || (checkOption == 6 && c == 0)) {
        this.onLight();

        this.greenLesser.setVisible(true);

        this.tweens.add({
          targets: this.greenLesser,
          ease: "Cubic",
          duration: 300,
          scale: { from: 0, to: 1 },
          yoyo: false,
          loop: 0,
        });
      } else {
        this.wrongOptionSelected();
      }
    } else if (correctOption == -1) {
      if ((checkOption == 1 && c == -1) || (checkOption == 2 && c == 1) || (checkOption == 3 && c == 0) || (checkOption == 4 && c == -1) || (checkOption == 5 && c == 0) || (checkOption == 6 && c == 1)) {
        this.onLight();

        this.greenGreater.setVisible(true);

        this.tweens.add({
          targets: this.greenGreater,
          ease: "Cubic",
          duration: 300,
          scale: { from: 0, to: 1 },
          yoyo: false,
          loop: 0,
        });
      } else {
        this.wrongOptionSelected();
      }
    } else if (correctOption == 0) {
      if ((checkOption == 1 && c == 0) || (checkOption == 2 && c == 0) || (checkOption == 3 && c == -1) || (checkOption == 4 && c == 1) || (checkOption == 5 && c == 1) || (checkOption == 6 && c == -1)) {
        this.onLight();

        this.greenEqual.setVisible(true);

        this.tweens.add({
          targets: this.greenEqual,
          ease: "Cubic",
          duration: 300,
          scale: { from: 0, to: 1 },
          yoyo: false,
          loop: 0,
        });
      } else {
        this.wrongOptionSelected();
      }
    }
  }

  wrongOptionSelected() {
    config.audio.incorrectaudio.play();
    if (c == 1) {
      this.playRightOptionWrong();
    } else if (c == 0) {
      this.playCenterOptionWrong();
    } else if (c == -1) {
      this.playLeftOptionWrong();
    }

    this.carLeftTurn.setVisible(false);
    this.carRightTurn.setVisible(false);

    hintOn = true;
  }

  leftBush(bus, x_scale) {
    bus.setScale((2 * (640 - bus.x)) / 640);

    if (bus.y > 200) {
      bus.setVelocity(0, 0);
      bus.setScale(0.1);
      bus.x = 640;
      bus.y = 110;
    } else if (True_tree) {
      bus.setVelocityX((-(640 + x_scale) * (641 - bus.x)) / (x_scale + 640));
      bus.setVelocityY(((770 - 110) * (641 - bus.x)) / (x_scale + 640));
    } else {
      bus.setVelocity(0, 0);
    }
  }

  rightBush(bus, x_scale) {
    bus.setScale((2 * (bus.x - 640)) / 640);

    if (bus.y > 250) {
      bus.setVelocity(0, 0);
      bus.setScale(0.1);
      bus.x = 640;
      bus.y = 110;
    } else if (True_tree) {
      bus.setVelocityX(((640 + x_scale) * (bus.x - 639)) / (x_scale + 640));
      bus.setVelocityY(((770 - 110) * (bus.x - 639)) / (x_scale + 640));
    } else {
      bus.setVelocity(0, 0);
    }
  }

  rockAnimation() {
    this.rock_1.setScale((1.5 * (640 - this.rock_1.x)) / 640);

    this.rock_2.setScale((1.5 * (this.rock_2.x - 640)) / 640);

    if (this.rock_1.y > 250) {
      this.rock_1.setVelocity(0, 0);
      this.rock_1.x = 640;
      this.rock_1.setScale(0.1);
      this.rock_1.y = 110;
    } else if (this.rock_2.y > 270) {
      this.rock_2.x = 640;
      this.rock_2.setVelocity(0, 0);
      this.rock_2.setScale(0.1);
      this.rock_2.y = 110;
    } else if (True_tree) {
      this.rock_1.setVelocityX((-(640 + 5000) * (641 - this.rock_1.x)) / 5640);
      this.rock_1.setVelocityY(((770 - 110) * (641 - this.rock_1.x)) / 5640);

      this.rock_2.setVelocityX(((640 + 5000) * (this.rock_2.x - 639)) / 5640);
      this.rock_2.setVelocityY(((770 - 110) * (this.rock_2.x - 639)) / 5640);
    } else {
      this.rock_1.setVelocity(0);
      this.rock_2.setVelocity(0);
    }
  }

  treeMotion() {
    this.trees.getChildren().forEach((tree) => {
      tree.setScale((640 - tree.x) / 1490);

      if (True_tree) {
        tree.setVelocityX((-(640 + 850) * (641 - tree.x)) / 1490);
        tree.setVelocityY(((770 - 110) * (641 - tree.x)) / 1490);
      } else {
        tree.setVelocity(0);
      }

      if (tree.x < -100) {
        const tree_1 = this.trees
          .create(config.width / 2, 110, "tree")
          .setOrigin(1, 1)
          .setScale(0.1, 0.1)
          .setDepth(4);
        tree.destroy();
      } else if (tree.y < 140) {
        tree.setDepth(6);
      }
    });

    this.right_trees.getChildren().forEach((tree) => {
      tree.setScale((tree.x - 640) / 1490);

      if (True_tree) {
        tree.setVelocityX(((640 + 850) * (tree.x - 639)) / 1490);
        tree.setVelocityY(((770 - 110) * (tree.x - 639)) / 1490);
      } else {
        tree.setVelocity(0);
      }

      if (tree.x > 1380) {
        tree.destroy();
        const tree_2 = this.right_trees
          .create(config.width / 2, 110, "tree")
          .setOrigin(0, 1)
          .setScale(0.1, 0.1)
          .setDepth(4);
      } else if (tree.y < 140) {
        tree.setDepth(6);
      }
    });
  }

  operatorMotion() {
    this.left.getChildren().forEach((operator) => {
      operator.setScale((1.5 * (640 - this.l_greater.x)) / 640);

      if (True_tree) {
        operator.setVelocityX((-17 * (641 - this.l_greater.x)) / 64);
        operator.setVelocityY((14 * (641 - this.l_greater.x)) / 64);
      } else {
        operator.setVelocity(0);
      }
    });

    this.right.getChildren().forEach((operator) => {
      operator.setScale((1.5 * (640 - this.l_greater.x)) / 640);
      if (True_tree) {
        operator.setVelocityX((17 * (641 - this.l_greater.x)) / 64);
        operator.setVelocityY((14 * (641 - this.l_greater.x)) / 64);
      } else {
        operator.setVelocity(0);
      }
    });

    this.mid.getChildren().forEach((operator) => {
      operator.setScale((1.5 * (640 - this.l_greater.x)) / 640);
      if (True_tree) {
        operator.setVelocityY((14 * (641 - this.l_greater.x)) / 64);
      } else {
        operator.setVelocity(0);
      }
    });
  }

  stripMotion() {
    this.left_strip.getChildren().forEach((strip) => {
      strip.setScale((640 - strip.x) / 640);

      if (True_strip) {
        strip.setVelocityX((-64 * (641 - strip.x)) / 64);
        strip.setVelocityY((110 * (641 - strip.x)) / 64);
      } else {
        strip.setVelocity(0);
      }

      if (strip.x < 140) {
        strip.destroy();

        const strip_1 = this.left_strip
          .create(config.width / 2, 110, "left strip")
          .setOrigin(1, 1)
          .setScale(0.1, 0.1)
          .setDepth(6);
        const strip_2 = this.right_strip
          .create(config.width / 2, 110, "right strip")
          .setOrigin(0, 1)
          .setScale(0.1, 0.1)
          .setDepth(6);
      }
    });

    this.right_strip.getChildren().forEach((strip) => {
      strip.setScale((strip.x - 640) / 640);

      if (True_strip) {
        strip.setVelocityX((64 * (strip.x - 639)) / 64);

        strip.setVelocityY((110 * (strip.x - 639)) / 64);
      } else {
        strip.setVelocity(0);
      }

      if (strip.x > 1160) {
        strip.destroy();
      }
    });
  }

  replayOperators() {
    leftButton.setDepth(10);
    rightButton.setDepth(10);

    this.greenEqual.setScale(0, 0);
    this.greenLesser.setScale(0, 0);
    this.greenGreater.setScale(0, 0);

    if (hintOn) {
      this.hintButton.play("pop");
      config.audio.hintaudio.play();

      this.time.delayedCall(
        500,
        () => {
          this.hintButton.play("breathe");
        },
        [],
        this
      );

      //this.hintButton.setInteractive({ cursor: "pointer",pixelPerfect: true});
    }

    attempt = replayCount + 1;

    if (replayCount == 0) {
      this.showPanel();
    }

    option = Phaser.Math.Between(1, 6);

    checkOption = option;

    this.makeOperatorsInvisible();

    if (option == 1) {
      this.l_greater.setVisible(true);
      this.m_equal.setVisible(true);
      this.r_lesser.setVisible(true);
    } else if (option == 2) {
      this.l_lesser.setVisible(true);
      this.m_equal.setVisible(true);
      this.r_greater.setVisible(true);
    } else if (option == 3) {
      this.l_equal.setVisible(true);
      this.m_greater.setVisible(true);
      this.r_lesser.setVisible(true);
    } else if (option == 4) {
      this.l_greater.setVisible(true);
      this.r_equal.setVisible(true);
      this.m_lesser.setVisible(true);
    } else if (option == 5) {
      this.l_lesser.setVisible(true);
      this.r_equal.setVisible(true);
      this.m_greater.setVisible(true);
    } else if (option == 6) {
      this.l_equal.setVisible(true);
      this.r_greater.setVisible(true);
      this.m_lesser.setVisible(true);
    }

    this.time.delayedCall(
      1000,
      () => {
        if (c == 1) {
          this.carRightTurn.setVisible(true);
        } else {
          this.carLeftTurn.setVisible(true);
        }

        this.carLeftCorrect.setVisible(false);
        this.carRightCorrect.setVisible(false);
        this.carCenterCorrect.setVisible(false);

        this.carLeftWrong.setVisible(false);
        this.carRightWrong.setVisible(false);
        this.carCenterWrong.setVisible(false);

        leftButton.setInteractive();
        rightButton.setInteractive();

        replayCount++;

        this.left.getChildren().forEach((operator) => {
          operator.setVelocity(0, 0);
          operator.x = 600;
          operator.y = 140;
        });

        this.mid.getChildren().forEach((operator) => {
          operator.setVelocity(0, 0);
          operator.x = 640;
          operator.y = 140;
        });

        this.right.getChildren().forEach((operator) => {
          operator.setVelocity(0, 0);
          operator.x = 680;
          operator.y = 140;
        });

        replay_test = true;
        checkTest = true;
      },
      [],
      this
    );
  }

  disableButtons() {
    //this.hintButton.disableInteractive();
    leftButton.disableInteractive();
    rightButton.disableInteractive();
    leftButton.setDepth(8);
    rightButton.setDepth(8);
  }

  disapperButtons() {
    leftButton.setVisible(false);
    rightButton.setVisible(false);

    leftButton.y = 830;
    rightButton.y = 830;
  }
  enableButtons() {
    leftButton.setDepth(10);
    rightButton.setDepth(10);

    this.tweens.add({
      targets: [leftButton, rightButton],
      ease: "Sine.easeOut",
      duration: 800,
      delay: 0,
      y: {
        getStart: () => 840,
        getEnd: () => 670,
      },
      yoyo: false,
      loop: 0,
      onComplete: function () {
        //tween.remove();
      },
    });

    leftButton.setInteractive().setVisible(true);
    rightButton.setInteractive().setVisible(true);
  }

  makeOperatorsInvisible() {
    this.l_greater.setVisible(false);
    this.l_equal.setVisible(false);
    this.l_lesser.setVisible(false);

    this.m_greater.setVisible(false);
    this.m_equal.setVisible(false);
    this.m_lesser.setVisible(false);

    this.r_greater.setVisible(false);
    this.r_equal.setVisible(false);
    this.r_lesser.setVisible(false);
  }
  replay() {
    if (replayCount < 3 && replay_test && this.l_greater.x < -500) {
      replay_test = false;
      this.replayOperators();
    }

    if (this.l_greater.y > 1500) {
      if (replayCount == 3) {
        this.removePanel();
        replayCount = 0;
        attempt = 0;
        qnum++;

        if (correct == 6 || qnum == 11) {
          t_test = false;
        }

        checkTest = false;
        hintOn = false;
      }
    }
  }
  onLight() {
    correct++;

    config.audio.correctaudio.play();

    if (c == 1) {
      this.playRightOptionCorrect();
    } else if (c == 0) {
      this.playCenterOptionCorrect();
    } else if (c == -1) {
      this.playLeftOptionCorrect();
    }
    replayCount = 3;

    if (correct == 1) {
      light_1.setVisible(true);
    } else if (correct == 2) {
      light_2.setVisible(true);
    } else if (correct == 3) {
      light_3.setVisible(true);
    } else if (correct == 4) {
      light_4.setVisible(true);
    } else if (correct == 5) {
      light_5.setVisible(true);
    } else if (correct == 6) {
      light_6.setVisible(true);
      gameState.gameWin = true;
    }
  }
}
